module.exports = __webpack_public_path__ + "media/11_8.5a8bcc88.wav";